export const getLangName = (lang: string) => {
  switch (lang) {
    case 'de':
      return 'Deutsch';
    case 'uk':
      return 'Ukrainian';
    case 'es':
      return 'Spanish';
    default:
      return 'English';
  }
};
